import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
} from "react-bootstrap";

import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import purchaseIcon from "../../assets/svg/purcahse_ic.svg";
import calendarIcon from "../../assets/svg/calendar_grey.svg";
import { getPRDetailsApi, updateStatusApi } from "./pr-api";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import numberFormat from "../common/number-format.js";
export const PurchaseRequestView = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const from = location.state?.from;
  const [isLoader, setIsLoader] = useState(false);
  const [productList, setProductList] = useState([]);
  const [purchaseRequestDetail, setPurchaseRequest] = useState({});

  const [stageListOption, setListStageOption] = useState([
    { value: "Request", label: "Request" },
    { value: "Quotation", label: "Quotation" },
    { value: "Negotiation", label: "Negotiation" },
    { value: "Final-Price", label: "Final-Price" },
    { value: "PO-Converted", label: "PO-Converted" },
  ]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const handleBack = () => {
    if (from === "vendor") {
      navigate("/viewVendor", {
        state: {
          activeTab: "request",
          id: location.state?.vendorId,
        },
      });
    } else {
      navigate("/pr");
    }
  };
  useEffect(() => {
    if (id != null) {
      getPRDetails();
    }
  }, [id]);

  const getPRDetails = async () => {
    try {
      const response = await getPRDetailsApi(id);

      if (response.data.success === true) {
        const prDetail = response.data.pr ?? {};
        setPurchaseRequest(prDetail);
        setProductList(prDetail.parts ?? []);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const SvgDottedLine = (color = "#D4DDE7", stroke = "1.6") => (
    <svg width="100%" height="4">
      <line
        x1="0"
        y1="2"
        x2="100%"
        y2="2"
        stroke={color}
        strokeWidth={stroke}
        strokeDasharray="4,4" // dash length, gap length
      />
    </svg>
  );
  const [isLoading, setIsLoading] = useState(false);
  const updateStatus = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      status: value,
    };
    try {
      const response = await updateStatusApi(id, bodyData);
      console.log("response....1", response);
      if (response.success === true) {
        getPRDetails();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-xl-row">
      <Sidebar currentfile="RFQ" />
      <div className="w-100 bg-half-white" style={{ background: "#F5F8FA" }}>
        <Navbar pageTitle="RFQ" />
        <div>
          <div className="bg-white px-2 py-2 ">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <div className="style-justify-start gap-3 my-3">
                  <div
                    className="bg-white style-justify-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "100px",
                      border: "1px solid #EBEBEB",
                    }}
                  >
                    <MoveLeft
                      className="cursor-pointer"
                      onClick={() => {
                        handleBack();
                      }}
                    />
                  </div>
                  <div
                    className=" style-justify-center"
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "100px",
                      background: "#F9F9F9",
                    }}
                  >
                    <img src={purchaseIcon} alt="purchase" />
                  </div>
                  <div className="ms-2">
                    <div className="fs-16 fw-400" style={{ color: "#212129" }}>
                      {purchaseRequestDetail.req_no ?? ""}
                    </div>

                    <div className="d-flex align-items-center gap-3 mt-2">
                      <div>
                        <img src={calendarIcon} alt="mail" />{" "}
                        <span
                          className="ms-1 fs-12 fw-400"
                          style={{ color: "#8790A1" }}
                        >
                          Exp. date
                        </span>{" "}
                        <span
                          className="ms-1 fs-12 fw-400"
                          style={{ color: "#4F46E5" }}
                        >
                          {purchaseRequestDetail.expected_delivery_date ?? ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex gap-3">
                {purchaseRequestDetail.status === "Pending" ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      id="dropdown-sort"
                      className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                      style={{
                        padding: "6px 12px",
                      }}
                    >
                      <span className="d-flex align-items-center px-1 gap-2">
                        <span
                          className="backgroundYellow"
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "3px",
                            display: "inline-block",
                          }}
                        ></span>

                        <span className="dropdown-text textcolor fs-13 fw-500">
                          {purchaseRequestDetail.status ?? "-"}
                        </span>

                        <span className="dropdown-toggle-arrow">
                          {/* <DownArrowIc /> */}
                        </span>
                      </span>
                    </Dropdown.Toggle>


                  </Dropdown>
                ) : (
                  <div
                    style={{
                      padding: "6px 12px",
                      height: "36px",
                    }}
                    className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                  >
                    <span className="d-flex align-items-center px-1 gap-2">
                      <span
                        className="backgroundYellow"
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "3px",
                          display: "inline-block",
                        }}
                      ></span>

                      <span className="dropdown-text textcolor fs-13 fw-500">
                        {purchaseRequestDetail.status ?? "-"}
                      </span>
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* <div
              className="m-2 rounded-4 p-3 style-justify-start"
              style={{ background: "#F8F8F8" }}
            >
              <div className="style-justify-start-column">
                <div style={{ position: "relative", width: "110px" }}>

                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      right: 0,
                      transform: "translateY(-50%)",
                      zIndex: 1, // behind the circle
                    }}
                  >
                    {SvgDottedLine("#4EBD7E", "1.6")}
                  </div>


                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      background: "#FFFFFF",
                      zIndex: 2, // above the dotted line
                      // margin: "0 auto", // centers horizontally within parent
                    }}
                  >
                    <img
                      src={
                        purchaseRequestDetail.status === "Request"
                          ? tickIcon
                          : requestIcon
                      }
                      alt="purchase"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </div>
                </div>

                <div
                  className="mt-2 fs-13 fw-600 "
                  style={{ color: "#4EBD7E" }}
                >
                  Requesting
                </div>
              </div>

              <div className="style-justify-center-column">
                <div style={{ position: "relative", width: "160px" }}>

                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      right: 0,
                      transform: "translateY(-50%)",
                      zIndex: 1, // behind the circle
                    }}
                  >
                    {SvgDottedLine()}
                  </div>


                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      background: "#FFFFFF",
                      border: "1.5px solid #4EBD7E",
                      zIndex: 2, // above the dotted line
                      margin: "0 auto", // centers horizontally within parent
                    }}
                  >
                    <img
                      src={
                        purchaseRequestDetail.status === "Quotation"
                          ? tickIcon
                          : quotationIcon
                      }
                      alt="purchase"
                    />
                  </div>
                </div>

                <div
                  className="mt-2 fs-13 fw-500 "
                  style={{ color: "#212129" }}
                >
                  Vendor Quotation
                </div>
              </div>

              <div className="style-justify-center-column">
                <div style={{ position: "relative", width: "160px" }}>

                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      right: 0,
                      transform: "translateY(-50%)",
                      zIndex: 1, // behind the circle
                    }}
                  >
                    {SvgDottedLine()}
                  </div>


                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      background: "#FFFFFF",
                      border: "0.6px solid #D4DDE7",
                      zIndex: 2, // above the dotted line
                      margin: "0 auto", // centers horizontally within parent
                    }}
                  >
                    <img
                      src={
                        purchaseRequestDetail.status === "Negotiation"
                          ? tickIcon
                          : negotiationIcon
                      }
                      alt="negotiation"
                    />
                  </div>
                </div>

                <div
                  className="mt-2 fs-13 fw-500 "
                  style={{ color: "#212129" }}
                >
                  Vendor Negotiation
                </div>
              </div>

              <div className="style-justify-center-column">
                <div style={{ position: "relative", width: "160px" }}>

                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      right: 0,
                      transform: "translateY(-50%)",
                      zIndex: 1, // behind the circle
                    }}
                  >
                    {SvgDottedLine()}
                  </div>


                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      background: "#FFFFFF",
                      border: "0.6px solid #D4DDE7",
                      zIndex: 2, // above the dotted line
                      margin: "0 auto", // centers horizontally within parent
                    }}
                  >
                    <img
                      src={
                        purchaseRequestDetail.status === "Final-Price"
                          ? tickIcon
                          : priceIcon
                      }
                      alt="price"
                    />
                  </div>
                </div>

                <div
                  className="mt-2 fs-13 fw-500 "
                  style={{ color: "#212129" }}
                >
                  Vendor Final Price
                </div>
              </div>

              <div className="style-justify-end-column">
                <div style={{ position: "relative", width: "110px" }}>

                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      right: 0,
                      transform: "translateY(-50%)",
                      zIndex: 1, // behind the circle
                    }}
                  >
                    {SvgDottedLine()}
                  </div>


                  <div className="style-justify-end">
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        background: "#FFFFFF",
                        border: "0.6px solid #D4DDE7",
                        zIndex: 2, // above the dotted line
                        //margin: "0 auto", // centers horizontally within parent
                      }}
                    >
                      <img
                        src={
                          purchaseRequestDetail.status === "PO-Converted"
                            ? tickIcon
                            : poConvertIcon
                        }
                        alt="price"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="mt-2 fs-13 fw-500 "
                  style={{ color: "#212129" }}
                >
                  PO Converted
                </div>
              </div>


            </div>  */}

          </div>

          <div className="m-2 bg-white rounded-4 p-3">
            <div className="row">
              <div className="col-12 ">
                <div className="row">
                  <div className="col-xl-12">
                    <p className="fs-18 fw-600 mb-0">Product </p>
                  </div>
                  <div style={{ overflowY: "visible" }}>
                    <div
                      className="mt-2 sticky-table-wrapper "
                      style={{ minHeight: "auto" }}
                    >
                      <table
                        className="sticky-table"
                        border="1"
                        cellPadding="10"
                        style={{
                          borderCollapse: "collapse",
                          width: "100%",
                        }}
                      >
                        <thead
                          style={{
                            height: "48px",
                            backgroundColor: "#F2F2F2", // ✅ Green background
                            color: "#212129", // ✅ White text
                            fontSize: "13px", // ✅ Font size
                            fontWeight: "700",
                            textAlign: "left",
                          }}
                        >
                          <tr>
                            <th className="ps-2">Product Name</th>
                            <th className="ps-2">Product ID</th>
                            <th className="ps-2">Unit</th>
                            <th className="ps-2">Total Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productList.map((row, index) => (
                            <tr
                              key={row.id}
                              style={{
                                height: "60px",
                                position: "relative",
                                overflow: "visible",
                              }}
                            >
                              <td
                                className="px-2 py-1"
                                style={{
                                  position: "relative",
                                  overflow: "visible",
                                }}
                              >
                                <div
                                  className="px-1 d-flex align-items-center"
                                  style={{
                                    minWidth: "134px",
                                    height: "36px",
                                    /* borderRadius: "8px",
                                    background: "#F8F8F8",
                                    border: "1px solid #EBEBEB", */
                                  }}
                                >
                                  {row.part_name}
                                </div>
                              </td>
                              <td className="px-2 py-1">
                                <div
                                  className="px-1 d-flex align-items-center"
                                  style={{
                                    minWidth: "134px",
                                    height: "36px",
                                    /* borderRadius: "8px",
                                    background: "#F8F8F8",
                                    border: "1px solid #EBEBEB", */
                                  }}
                                >
                                  {row.part_code}
                                </div>
                              </td>
                              <td className="px-2 py-1">
                                <div
                                  className="px-1 d-flex align-items-center"
                                  style={{
                                    minWidth: "134px",
                                    height: "36px",
                                    /* borderRadius: "8px",
                                    background: "#F8F8F8",
                                    border: "1px solid #EBEBEB", */
                                  }}
                                >
                                  {row.unit}
                                </div>
                              </td>
                              <td className="px-2 py-1">
                                <div
                                  className="px-1 d-flex align-items-center"
                                  style={{
                                    minWidth: "134px",
                                    height: "36px",
                                    /* borderRadius: "8px",
                                    background: "#F8F8F8",
                                    border: "1px solid #EBEBEB", */
                                  }}
                                >
                                  {row.quantity}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="m-2 bg-white rounded-4 p-3">
            <div className="style-justify-start gap-3">
              <div
                className="cursor-pointer rounded-pill py-2 px-4 d-flex justify-content-center align-items-center"
                style={{ minWidth: "86px", background: "#4F46E5" }}
              >
                <span className="fs-13 fw-600" style={{ color: "#FFFFFF" }}>
                  Details
                </span>
              </div>
            </div>
            <div className="mt-2 col-xl-12">
              <p className="fs-18 fw-600 mb-0">Request details </p>
              <div className="mt-2">
                <div className="style-justify-start mt-1">
                  <div
                    className="fs-14 fw-400"
                    style={{ width: "150px", color: "#8790A1" }}
                  >
                    Vendor Name
                  </div>
                  <div className="fs-14 fw-500" style={{ color: "#212129" }}>
                    {purchaseRequestDetail.vendor_name ?? "-"}
                  </div>
                </div>

                <div className="style-justify-start mt-2">
                  <div
                    className="fs-14 fw-400"
                    style={{ width: "150px", color: "#8790A1" }}
                  >
                    Request No
                  </div>
                  <div className="fs-14 fw-500" style={{ color: "#212129" }}>
                    {purchaseRequestDetail.req_no ?? "-"}
                  </div>
                </div>

                <div className="style-justify-start mt-2">
                  <div
                    className="fs-14 fw-400"
                    style={{ width: "150px", color: "#8790A1" }}
                  >
                    Stage
                  </div>
                  <div className="fs-14 fw-500" style={{ color: "#212129" }}>
                    {purchaseRequestDetail.status ?? "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
